/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// react
import React from "react";
import { Link } from "react-router-dom";
// Redux Toolkit
import { useSelector } from "react-redux";
import { selectUser } from "../../../../store/userSlice";
// BASE components
import BASESvgIcon from "../../../../../@BASE/core/BASESvgIcon";
import authRoles from "../../../../auth/authRoles";
// Material UI components
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

function ProjectsListingHeader(props) {
  const { logo, title, project_id } = props;
  const user = useSelector(selectUser);

  return (
    <div className="flex items-center px-32 py-16">
      <img
        className="flex-none m-0 w-32 mr-16"
        src={`${window.location.origin.toString()}/assets/images/logos/${logo}.png`}
        alt="Client logo"
      />
      <Typography
        className="grow text-28 font-extrabold tracking-wide leading-none"
      >
        {title}
      </Typography>
      {(authRoles.admin.includes(user.role)) && (
        <Button
          to={`${project_id}/edit`}
          component={Link}
          className="flex-none px-16"
          variant="outlined"
          startIcon={
            <BASESvgIcon className="" size={20}>
              heroicons-outline:pencil-alt
            </BASESvgIcon>
          }
        >
          Edit
        </Button>
      )}
    </div>
  )
}

export default ProjectsListingHeader;